import { call, put, takeEvery } from 'redux-saga/effects';
// import { history } from '../../../../../config/history';
import { createBikeModelVariant } from '../../requests/create_bike_model_variant_request';
import { createBikeModelVariantRequestSuccess, createBikeModelVariantRequestFailure } from '../actions/create_bike_model_variant.actions';
import { CREATE_BIKE_MODEL_VARIANTS_REQUEST } from '../constants/create_bike_model_variant.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* createBikeModelVariantRequest({ params, _id }) {
    const { result, error } = yield call(createBikeModelVariant, params, _id);
    if (result) {
        yield put(createBikeModelVariantRequestSuccess());
        message_success('Bike model variant created successfully!');
        // history.goBack();
    } else {
        yield put(createBikeModelVariantRequestFailure('Something gone wrong!'));
        error._message.includes('duplicate')
            ? message_error('A variant with that year or name already exists!')
            : message_error('Something gone wrong!');
    }
}

export default function* createBikeModelVariantsSaga() {
    yield takeEvery(CREATE_BIKE_MODEL_VARIANTS_REQUEST, createBikeModelVariantRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_variant_create/redux/sagas/create_bike_model_variants.saga.js